import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Box, Button } from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";

import ErrorMessage from "../../helpers/ErrorMessage";

interface FileUploadProps<FileMetaData extends object = {}> {
  disabled?: boolean;
  label?: string;
  annotateFile?: (_f: File) => FileMetaData;
}

const FileUpload = <FileMetaData extends object = {}>({
  disabled,
  label = "Upload Files",
  annotateFile = (_file: File) => ({}) as FileMetaData,
}: FileUploadProps<FileMetaData>) => {
  const field = useFieldContext<({ file: File } & FileMetaData)[]>();

  return (
    <Box>
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<UploadFileIcon />}
        fullWidth={false}
        color="primary"
        disabled={disabled}
      >
        {label}
        <input
          style={{
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: 1,
            overflow: "hidden",
            position: "absolute",
            bottom: 0,
            left: 0,
            whiteSpace: "nowrap",
            width: 1,
          }}
          type="file"
          onChange={(e) => {
            const uploadedFiles = e.target.files || [];

            const annotatedFiles = [...uploadedFiles].map((file) => ({
              ...annotateFile(file),
              file,
            }));

            field.handleChange([...field.state.value, ...annotatedFiles]);
          }}
          multiple
        />
      </Button>
      <ErrorMessage />
    </Box>
  );
};
export default FileUpload;
